import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Card, Row, Button } from 'reactstrap';
import BulkCaseForm from './BulkcaseForm/index';
import './style.scss';
import { DEFUALT_FETCH_LIST_REQUEST, DEFUALT_INTERNATIONAL_FETCH_LIST_REQUEST,BULK_QUICK_CASE, BULK_CASE,BULK_INTERNATIONAL_CASE } from './constants';
import { fetchUploadList,uploadBulkCases, downloadTemplate, downloadBulkCasesFile,uploadQuickBulkCases } from './action';
import { fetchQuickReportCases, fetchProductTemplate, uploadManualSectionData, downloadManualSectiontemplateRequest, 
    downloadQuickReportSummaryRequest, downloadQuickReportSummaryResponse,downloadQuickReportCaseCreationTemplate,downloadQuickReportStatusFileRequest, downloadQuickReportCrawlerStatusFile,initiateOrStopQuickCrawlersRequest } from '../Bulk-Case/QuickReportBulkCase/action'
import TableView from './TableView/index';
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import { Preloading } from '../../../components/UI/Preloader/action';
import { dataStatusCheck } from './helper';
import TemplateModal from './QuickReportBulkCase/TemplateModal';
import moment from 'moment';

class CreateBulkCase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionFile: '',
            uploadListData: [],
            loading: false,
            selectedCorporate: [],
            uploadError: [],
            updateFlag: false,
            caseTypeDropdownOpen: false,
            selectedCaseType: "",
            openModal : false
        }
        this.refreshInterval = null;
    }
    
    componentDidMount(){
        this.props.preloading(true);
        this.props.fetchUploadList(DEFUALT_FETCH_LIST_REQUEST);
        this.setState({selectedCaseType: BULK_CASE });
    }

    componentDidUpdate(prevProps) {
        if(this.props.quickCrawlerResponse !== prevProps.quickCrawlerResponse){
            this.props.preloading(false);
            if(this.props.quickCrawlerResponse && this.props.quickCrawlerResponse.status === "SUCCESS"){
                toast.info(
                    <div>
                        {this.props.quickCrawlerResponse ? this.props.quickCrawlerResponse.data :""}
                    </div>
                );
            }else{
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again Or Contact Dev Team!!
                    </div>
                );
            }
           
            
        }

        if(this.props.productTemplateSuccess !== prevProps.productTemplateSuccess){
            this.setState({corporateId : this.props.productTemplateSuccess ? this.props.productTemplateSuccess.corporateId : ""})
            this.props.preloading(false);
        }
        if(this.props.productTemplateFailure !== prevProps.productTemplateFailure){
            this.props.preloading(false);
            this.toogleQuickReportModal();
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                </div>
            );

        }
        if(this.props.uploadData !== prevProps.uploadData){
            this.props.preloading(false);
            if(this.props.uploadData.status === "SUCCESS"){
                toast.success(
                    <div>
                        <i ></i>&nbsp;{this.props.uploadData.message}
                    </div>
                );
            }else if(this.props.uploadData.status === "FAILURE"){
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.uploadData.data.message}
                    </div>
                );
            }
            
        }
        if(this.props.downloadManualSection !== prevProps.downloadManualSection){
            this.props.preloading(false);
            if(this.props.downloadManualSection.status === "SUCCESS"){
                const data= this.props.downloadManualSection.templateData;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${this.state.croporateName}_${this.state.sectionName}.xlsx`)
            }else if(this.props.downloadManualSection.status === "FAILURE"){
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }
        if(this.props.summaryData !== prevProps.summaryData){
            this.props.preloading(false);
            if(this.props.summaryData.status === "SUCCESS"){
                const data= this.props.summaryData.summary;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${this.state.croporateName}_${"Quick_Report_Summary"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            }else if(this.props.summaryData.status === "FAILURE"){
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }

        if(this.props.quickReportCreationTemplate !== prevProps.quickReportCreationTemplate){
            this.props.preloading(false);
            if(this.props.quickReportCreationTemplate.status === "SUCCESS"){
                const data= this.props.quickReportCreationTemplate.quickReportCreationTemplate;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"Quick_Report_Summary_Template"}.xlsx`)
            }else if(this.props.quickReportCreationTemplate.status === "FAILURE"){
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }

        const { downloadTemplateSuccess, downloadTemplateFailure,uploadListSuccess, uploadListFailure, downloadFileSuccess, downloadFileFailure, uploadSuccess, uploadFailure } = this.props
        if (downloadTemplateSuccess !== prevProps.downloadTemplateSuccess) {
            var blob = new Blob([downloadTemplateSuccess], { type: 'application/octet-stream' });
            fileSaver.saveAs(blob, this.state.selectedCaseType.replace(" ","_")+'_Template.xlsx');
        }
        if (downloadTemplateFailure !== prevProps.downloadTemplateFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.downloadTemplateFailure.data.message}
                </div>
            );
        }
        
        if (uploadListSuccess !== prevProps.uploadListSuccess) {
            this.props.preloading(false);
            this.setState({
                uploadListData: uploadListSuccess,
                loading: false
            }, () => {
                const statusFlag = dataStatusCheck(uploadListSuccess.recordList);
                if (statusFlag) {
                    this.refreshInterval = setTimeout(() => {
                        if(this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
                            this.uploadFetch(DEFUALT_INTERNATIONAL_FETCH_LIST_REQUEST);
                        }else{
                            this.uploadFetch(DEFUALT_FETCH_LIST_REQUEST);
                        }
                    }, 10000)
                } else {
                    if (this.refreshInterval) {
                        clearTimeout(this.refreshInterval);
                    }
                }
            })
        }
        if (uploadListFailure !== prevProps.uploadListFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.uploadListFailure.data.message}
                </div>
            );
        }
        if (downloadFileSuccess !== prevProps.downloadFileSuccess) {
            window.open(downloadFileSuccess);
        }

        if(this.props.crawlerStatus !== prevProps.crawlerStatus){
            this.props.preloading(false);
            if(this.props.crawlerStatus.status === "SUCCESS"){
                let blob = new Blob([this.props.crawlerStatus.statusFile], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${this.state.croporateName}_Quick_Report_Crawler_Status_file.xlsx`)
            }else if (this.props.crawlerStatus.status === "FAILURE"){
                toast.error( <div>
                    <i className="fa fa-exclamation-triangle"></i> Please Try again !!!
                </div>)
            }
        }

        if(this.props.quickReportStatus !== prevProps.quickReportStatus){
            this.props.preloading(false);
            if(this.props.quickReportStatus.status === "SUCCESS"){
                window.open(this.props.quickReportStatus.statusFile);
            }else if (this.props.quickReportStatus.status === "FAILURE"){
                toast.error( <div>
                    <i className="fa fa-exclamation-triangle"></i> Please Try again !!!
                </div>)
            }
        }
        if (downloadFileFailure !== prevProps.downloadFileFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.downloadFileFailure.data.message}
                </div>
            );
        }
        if (uploadSuccess !== prevProps.uploadSuccess) {
            toast.success(
                <div>
                    Upload Successfully
                </div>
            );
            this.setState({
                transactionFile: null,
                selectedCorporate: [],
                uploadError: [],
                updateFlag: true
            });
            if(this.state.selectedCaseType === BULK_CASE ){
                this.uploadFetch(DEFUALT_FETCH_LIST_REQUEST);
            }
            else if(this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
                this.uploadFetch(DEFUALT_INTERNATIONAL_FETCH_LIST_REQUEST);
            }
            
        }
        if (uploadFailure !== prevProps.uploadFailure) {
            this.props.preloading(false)
            if (Array.isArray(uploadFailure.data.message)) {
                this.setState({
                    uploadError: uploadFailure.data.message,
                    updateFlag: false
                })
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.uploadFailure.data.message}
                    </div>
                );
            }
        }

    }
    uploadFetch = (data) => {
        this.setState({
            loading: true
        })
        if(this.state.selectedCaseType === BULK_CASE || this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
            this.props.fetchUploadList(data);
        }else{
            this.props.fetchQuickReportCases(data);
        }
        
    }

    fetchQuickReportCaseData = () => {
        this.props.preloading(true);
        this.props.fetchQuickReportCases(DEFUALT_FETCH_LIST_REQUEST);
    }


    fetchBulkCaseData = () => {
        this.props.preloading(true);
        this.props.fetchUploadList(DEFUALT_FETCH_LIST_REQUEST);
    }

    fetchInternationalBulkCaseData = () => {
        this.props.preloading(true);
        this.props.fetchUploadList(DEFUALT_INTERNATIONAL_FETCH_LIST_REQUEST);
    }

    handleSubmit = () => {
        const tempRequestBody = {
            file  : this.state.transactionFile,
            corporateId : this.state.selectedCorporate.id
        }
        if(this.state.selectedCaseType === BULK_QUICK_CASE){
            this.props.uploadQuickBulkCases(tempRequestBody);
        } else if(this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
            tempRequestBody.caseType = 'INTERNATIONAL'
            this.props.uploadBulkCases(tempRequestBody);
        }else
        {   // Default is Bulk Cases
            tempRequestBody.caseType = 'DOMESTIC'
            this.props.uploadBulkCases(tempRequestBody);
        }
        
        this.props.preloading(true);
    }

    handleDownloadTemplate = () => {
        if(this.state.selectedCaseType === BULK_QUICK_CASE){
            this.props.preloading(true);
            this.props.downloadQuickReportCaseCreationTemplate();
        }else if(this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
            this.props.downloadTemplate("INTERNATIONAL")
        }
        else{
            this.props.downloadTemplate("DOMESTIC")
        }
        
    }

    handleSelectedCorporate = (data) => {
        this.setState({
            selectedCorporate: data
        })
    }

    handleCaseTypeChange = (newCaseType) => {
        if(newCaseType === BULK_QUICK_CASE ){
            this.fetchQuickReportCaseData()
        }else if(newCaseType === BULK_INTERNATIONAL_CASE){
            this.fetchInternationalBulkCaseData()
        }
        else{
            this.fetchBulkCaseData()
        }
        this.setState({ selectedCaseType: newCaseType });
    }

    uploadExcel = (event) => {
        this.setState({
            transactionFile: event.target.files[0]
        })
        event.preventDefault();
        event.target.value = null;
    }
    
    handleClear = () => {
        this.setState({
            uploadError: []
        })
    }

    handleDownloadOrignalFile = (data) => {
        if(this.state.selectedCaseType === BULK_QUICK_CASE){
            this.props.downloadQuickReportStatusFileRequest(data.fileKey);
        }
        else if(this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
            this.props.downloadBulkCasesFile(data.fileKey);
        }
        else{
            this.props.downloadBulkCasesFile(data.fileKey);
        } 
    }      

    handleDownloadFailedFile = (data) => {
        if(this.state.selectedCaseType === BULK_QUICK_CASE){
            this.props.downloadQuickReportStatusFileRequest(data.failureFileKey);
        }
        else if(this.state.selectedCaseType === BULK_INTERNATIONAL_CASE){
            this.props.downloadBulkCasesFile(data.failureFileKey);
        }
        else{
            this.props.downloadBulkCasesFile(data.failureFileKey);
        } 
    }
    
    toggle = () => {
        this.setState((prevState) => ({
            caseTypeDropdownOpen: !prevState.caseTypeDropdownOpen
        }))
    }

    toogleQuickReportModal = () =>{
        this.setState({ openModal : !this.state.openModal })
    }

    fetchProductDetail = (productId, id, name) =>{
        this.props.preloading(true);
        this.setState({ selectedProductId : productId, quickCaseCreationRecordId : id , croporateName : name})
        this.props.fetchProductTemplate({productId : productId})
    }

    uploadTemplate = (data) => {
        this.props.uploadManualSectionData({...data, reportRequestCaseId : this.state.quickCaseCreationRecordId, type : data.type, corporateId : this.state.corporateId});
        this.props.preloading(true);
        this.toogleQuickReportModal();
    }

    downloadTemplate = (data) =>{
        this.setState({sectionTemplateId : data.sectionTemplateId, sectionName : data.sectionName})
        this.props.preloading(true);
        this.props.downloadManualSectiontemplateRequest({...data, quickCaseCreationRecordId : this.state.quickCaseCreationRecordId, type : data.type});
        this.toogleQuickReportModal();

    }

    downlodQuickReportSummary = (data) => {
        console.log(data)
        this.setState({croporateName : data.name})
        
        this.props.downloadQuickReportSummaryRequest(data);
        this.props.preloading(true);
    }

    downloadCrawlerStatusFile = (data) => {
        this.props.preloading(true);
        this.setState({croporateName : data.name})
        this.props.downloadQuickReportCrawlerStatusFile(data);
    }

    fetchCrawlerProduct = (type) =>{
        this.props.preloading(true);
        this.props.fetchProductTemplate({productId : this.state.selectedProductId, type : type })
    }

    handleStartStopButton = (e) => {
        e.preventDefault()
        this.props.preloading(true);
        this.props.initiateOrStopQuickCrawlersRequest();

    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Bulk Case Creation</h4>
                </div>
                <Card>
                    <Row>
                        <Col sm='15'>
                            <BulkCaseForm updateFlag={this.state.updateFlag} 
                                selectedCorporateCallback={this.handleSelectedCorporate} 
                                onCaseTypeChange={this.handleCaseTypeChange}/>
                        </Col>
                        <Col sm='6' className="upload-bulk-cases">
                            <Row className="text-muted ml-1">Excel Sheet Uploader</Row>
                            <Row color="primary" className="btn btn-primary ml-0 position-relative upload-payment-data" title="Upload New Risk Factor">
                                <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                                <i className="fa fa-paperclip color-888 rotate-90deg p-1" /> &nbsp;Browse File(s)
                            </Row>
                            <Row className="text-muted ml-1">{(this.state.transactionFile) ? this.state.transactionFile.name : ''}</Row>
                            <Row  onClick={this.handleDownloadTemplate} color="primary" style={{marginTop : "2rem" , width: "auto"}} className=" ml-0 position-relative upload-payment-data" title="Upload New Risk Factor">
                                <div className='download-template-text'><span className='download-template' >Click here</span>&nbsp; to download template</div>
                            </Row>
                        </Col>
                        <Col sm='3' className='upload-bulk-submit'>
                            <Row>
                                <Button color='primary' onClick={this.handleSubmit}>Submit</Button>
                            </Row>
                            {this.state.selectedCaseType === BULK_QUICK_CASE && <Row style={{ marginTop: "2rem", width: "auto" }} className=" ml-0 position-relative upload-payment-data">
                                <Button color='primary' onClick={e => this.handleStartStopButton(e)}>Start/Stop </Button>
                            </Row>}

                        </Col>
                    </Row>
                    <ul>
                        {
                            (Array.isArray(this.state.uploadError)) ? this.state.uploadError.map((data, index) => {
                                return (
                                    <li className='text-danger upload-error' key={data}>{index + 1}{' - '}{data} </li>
                                )
                            }) : ''
                        }
                    </ul>
                    {
                        (this.state.uploadError.length > 0) ? <span className="clear-error" onClick={this.handleClear}>clear</span> : ''
                    }
                    <TableView tasks={this.state.uploadListData}
                        loading={this.state.loading}
                        caseType = {this.state.selectedCaseType}
                        // status={constant.PENDING}
                        downloadOrignal={this.handleDownloadOrignalFile}
                        downloadFailedFile={this.handleDownloadFailedFile}
                        onFetchPage={this.uploadFetch} 
                        fetchProductDetail = {this.fetchProductDetail}
                        downloadCrawlerStatusFile = {this.downloadCrawlerStatusFile}
                        downlodQuickReportSummary = { this.downlodQuickReportSummary}
                        toogleQuickReportModal = {this.toogleQuickReportModal}/>
                        
                        
                       { this.state.openModal && <TemplateModal open = {this.state.openModal} toggle = {this.toogleQuickReportModal} productTemplate = {this.props.productTemplateSuccess} uploadTempalte ={this.uploadTemplate}  downLoadTempalte = {this.downloadTemplate} fetchProductDetail = {this.fetchCrawlerProduct} />}
                       <div style={{marginBottom : "1rem"}} className='download-template-text'></div>
                </Card>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    downloadTemplateSuccess: state.bulkCase.downloadTemplateSuccess,
    downloadTemplateFailure: state.bulkCase.downloadTemplateFailure,
    uploadListSuccess: state.bulkCase.uploadListSuccess,
    uploadListFailure: state.bulkCase.uploadListFailure,
    downloadFileSuccess: state.bulkCase.downloadFileSuccess,
    downloadFileFailure: state.bulkCase.downloadFileFailure,
    uploadSuccess: state.bulkCase.uploadBulkSuccess,
    uploadFailure: state.bulkCase.uploadBulkFailure,
    uploadQuickSuccess: state.bulkCase.uploadQuickBulkSuccess,
    uploadQuickFailure: state.bulkCase.uploadQuickBulkFailure,
    productTemplateSuccess : state.quickReport.productSuccess,
    productTemplateFailure : state.quickReport.productFailure,
    uploadData : state.quickReport.uploadData,
    downloadManualSection : state.quickReport.downloadManualSection,
    summaryData : state.quickReport.summaryData,
    quickReportCreationTemplate : state.quickReport.quickReportCreationTemplate,
    quickReportStatus : state.quickReport.quickReportStatus,
    crawlerStatus : state.quickReport.crawlerStatus,
    quickCrawlerResponse : state.quickReport.quickCrawlerResponse
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchUploadList: (data) => { dispatch(fetchUploadList(data)) },
    uploadBulkCases: (data) => { dispatch(uploadBulkCases(data)) },
    uploadQuickBulkCases: (data) => {dispatch(uploadQuickBulkCases(data))},
    downloadTemplate: (data) => { dispatch(downloadTemplate(data)) },
    downloadBulkCasesFile: (data) => { dispatch(downloadBulkCasesFile(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    fetchQuickReportCases : (data) => {dispatch(fetchQuickReportCases(data))},
    fetchProductTemplate : (data) => { dispatch(fetchProductTemplate(data))},
    uploadManualSectionData : (data) => {dispatch(uploadManualSectionData(data))},
    downloadManualSectiontemplateRequest : (data) => { dispatch(downloadManualSectiontemplateRequest(data))},
    downloadQuickReportSummaryRequest : (data) => { dispatch(downloadQuickReportSummaryRequest(data))},
    downloadQuickReportSummaryResponse : (data) => { dispatch(downloadQuickReportSummaryResponse(data))},
    downloadQuickReportCaseCreationTemplate : (data) => {dispatch(downloadQuickReportCaseCreationTemplate(data))},
    downloadQuickReportStatusFileRequest : (data) => {dispatch(downloadQuickReportStatusFileRequest(data))},
    downloadQuickReportCrawlerStatusFile : (data) => { dispatch (downloadQuickReportCrawlerStatusFile(data))},
    initiateOrStopQuickCrawlersRequest : (data) => {dispatch(initiateOrStopQuickCrawlersRequest(data))}
});
export default CreateBulkCase = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateBulkCase)